module.exports = __webpack_public_path__ + "static/img/PastPhotosbgS.d1ee4bd1.png";